import fetchServer from "../../fetchServer";

export default async function createAPIKeyByAdmin(data) {
  let result = {
    return: 0,
    msg: "Something went wrong creating API key as admin!",
  };

  await fetchServer({ method: "POST", url: "/main/v1/apikey/byAdmin", data })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = {
          return: 1,
          msg: res?.data?.message || "Successful",
          data: res?.data?.data,
        };
      } else if (res?.data?.error) result["msg"] = res.data.error;
      else if (res?.error) result["msg"] = res.error;
      else if (res?.data?.message) result["msg"] = res.data.message;
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
